export default __webpack_public_path__ + "static/a2-f3d8b0d8f13be173465c4e39fd0cad8f.jpg";